import $fn from '@/utils/fn';
import {
    getUserInfo,
    getMenu,
    DetailList
} from '@/req/user';
import { tagList, byRand } from '@/req/home'
export default {
    namespaced: true,
    state: {
        // 版本id
        versions: "",
        // 特色标签
        tag: "",
        // 游戏款数
        rankName: "",
        // game标签
        gameTag: "全部游戏",
        // 数据
        rankData: [],
        // header标签选择
        screeningResults: "321",
        // 标签信息
        featurelist: [],
        // 版本信息
        versionList: [],
        // list组件数据
        listData: [],
        oldGameIdList: [],
        search: false,
        active: null,
        actives: null,
    },
    // getters:{},
    mutations: {
        setVersions(state: { versions: any; }, obj: any) {
            state.versions = obj
        },
        setFeaturelist(state: { featurelist: any; }, obj: any) {
            state.featurelist = obj;
        },
        setScreeningResults(state: { screeningResults: any; }, obj: any) {
            state.screeningResults = obj;
        },
        setVersionList(state: { versionList: any; }, obj: any) {
            state.versionList = obj;
        },
        setByRand(state: { rankData: any; rankName: any; }, obj: any) {
            state.rankName = obj.gameTotalNumber;
            state.rankData = state.rankData.concat(obj.gameList)
        },
    },
    actions: {
        async updateVerison({
            commit,
            // tslint:disable-next-line:align
        }, verisons) {
            commit('setVersions', verisons)
        },
        async getFeaturelist({
            commit,
            rootState
            // tslint:disable-next-line:align
        }) {
            rootState.discover.screeningResults = "";
            const obj = {
                token: $fn.cookies.getToken(),
            }
            const res = await tagList(obj);
            const arr = res.data.tagList.map(item => {
                item.checked = false;
                return item;
            })
            const arrsion = res.data.versionList.map(item => {
                item.checked = false;
                return item;
            })
            commit('setFeaturelist', arr)
            commit('setVersionList', arrsion)
        },
        async getScreening({
            commit,
            // tslint:disable-next-line:align
        }, screeningResults) {
            commit('setScreeningResults', screeningResults)
        },
        async getByRand({
            commit,
            rootState
        }) {
            const obj = {
                token: $fn.cookies.getToken(),
                versionid: rootState.discover.versions,
                tag: rootState.discover.tag,
                oldGameIdList: rootState.discover.oldGameIdList
            }
            const res = await byRand(obj);
            commit('setByRand', res.data);
        },
        async getEmptyByRand({
            commit,
            rootState
        }) {
            rootState.discover.rankData = [];
            rootState.discover.oldGameIdList = [];
            const obj = {
                token: $fn.cookies.getToken(),
                versionid: rootState.discover.versions,
                tag: rootState.discover.tag,
                oldGameIdList: rootState.discover.oldGameIdList
            }
            const res = await byRand(obj);
            commit('setByRand', res.data);
        },
        // async initDetailList({ commit }) {
        //     this.getPlatform(commit);
        //     this.getGame(commit)
        //     this.getGametype(commit)
        //     this.getGroup(commit)
        //     this.getServerlist(commit)
        //     this.getSpacetype(commit)
        // },

        /*****************************************  ********************************/
        // 设置当前用户角色
        async updateInfo({
            commit,
        }) {
            try {
                // const res = await getUserInfo()
                // if ($fn.n(res.code) === 200) {
                //     commit('setInfo', res.data)
                // } else {
                //     if (window.location.href.indexOf('/login') === -1) {
                //         window.App.$router.push({
                //             path: '/login',
                //         })
                //     }
                // }
            } catch (err) {
                if (window.location.href.indexOf('/login') === -1) {
                    window.App.$router.push({
                        path: '/login',
                    })
                }
            }
        },
    },
}
